import store from "../store"

function is_logged_on() {
  const auth = store.getState().auth
  const user = auth.current_user
  return ( auth.isAuthenticated && (user.data !== undefined || user.data !== null || Object.keys(user.data).length > 0) ) || false
}

function is_validating() {
  const auth = store.getState().auth
  return auth.isValidating
}

function is_admin() {
  const auth = store.getState().auth
  const { role } = auth.current_user.data
  return ( role === "admin" )
}

function is_manager() {
  const auth = store.getState().auth
  const { role } = auth.current_user.data
  return ( role === "admin" || role === "manager" )
}

function get_user() {
  return is_logged_on() ? store.getState().auth.current_user.data : null
}

function setFormControlClass(field) {
  // clear and valid

  if (field.pristine) {
    return "input-group"
  }
  // touched and valid
  if ( field.valid ) {
    return "input-group has-success"
  }
  // invalid
  return "input-group has-error"
}

function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.replace(/_/g, " ").slice(1);
}

function is_numeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export {
  is_logged_on,
  is_validating,
  is_admin,
  is_manager,
  get_user,
  capitalize,
  setFormControlClass,
  is_numeric
}



// WEBPACK FOOTER //
// ./src/js/helpers/index.js